import { Component } from "react";
import { getCurrentFunctionName } from "../../../performanceModeManager";
import DatePicker from "../../Input/DatePicker";

class InterventionDatePicker extends Component {
	state = {
		opened: false,
	};

	onDateChange(date) {
		let fieldValue = this.props.value;
		fieldValue.value_date = date;
		this.props.fieldValueChange(fieldValue);
		this.close();
	}

	onDateClick() {
		if (!this.state.opened && !this.props.inputProperties.disabled) this.open();
	}

	open() {
		if (!this.props.inputProperties.disabled) this.setState({ opened: true });
	}

	close() {
		this.setState({ opened: false });
	}

	render() {
		console.perfLog(getCurrentFunctionName());
		return (
			<div className="full_size control-margin-top" onClick={this.onDateClick.bind(this)}>
				<DatePicker
					{...this.props.inputProperties}
					value={this.props.value.value_date ? this.props.value.value_date : undefined}
					label={this.props.model.name}
					invalidDateMessage="La date est invalide"
					invalidLabel="La date est invalide"
					format="DD/MM/YYYY"
					onOpen={this.open.bind(this)}
					onClose={this.close.bind(this)}
					open={this.state.opened}
					className={
						this.props.inputProperties.className +
						" full_size " +
						(this.props.inputProperties.disabled ? "light-disabled" : "")
					}
					onChange={this.onDateChange.bind(this)}
				/>
			</div>
		);
	}
}

export default InterventionDatePicker;
